import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    text: {
        pointerEvents: "none"
    }
}));

function NumberCell({ formattedValue }: GridRenderCellParams)
{
    const classes = useStyles();
    return <Typography className={classes.text}>{formattedValue}</Typography>;
}

const mapStateToProps = (store: never) => ({
});
export default connect(mapStateToProps, {
})(NumberCell);